/* global addeventatc */
'use strict';

const find = require('lodash/find');
const assign = require('lodash/assign');
const dates = require('util/dates');
const ICS = require('util/ical');
const getCookie = require('util/getCookie');

const ignoredStatuses = [
    3,  // Sold Out
];

function controller($attrs, $scope, inventoryService, locale, appConfig) {
    const vm = this;
    const now = dates.moment();

    vm.loading = true;
    vm.members_only = false;
    vm.unavailable = false;
    vm.on_sale_dates = [];
    vm.booking_status = '';
    vm.booking_url = false;
    vm.production = false;
    vm.sold_out = false;
    vm.logged_in = getCookie(document.cookie, '_bo_logged_in') !== null;
    vm.current_mos = parseInt(getCookie(document.cookie, '_current_mos'));
    vm.current_mos = vm.current_mos ? vm.current_mos : appConfig.public_mos;
    vm.is_bookable = false;

    vm.init = () => {
        $attrs.prodSeasonNo = parseInt($attrs.prodSeasonNo);
        $attrs.perfNo = parseInt($attrs.perfNo);

        inventoryService.getEvents().then(events => {
            const production = find(events, event => {
                return event.prod_season_no === $attrs.prodSeasonNo;
            });

            if (!production) {
                vm.unavailable = true;
                return;
            }

            vm.production = assign({}, production);

            if ($attrs.perfNo) {
                vm.production.performances = vm.production.performances.filter(perf => {
                    return perf.perf_no === $attrs.perfNo;
                });
            }

            vm.production.dynamic_price = vm.production.price_description;
            if (!vm.production.price_description) {
                vm.production.dynamic_price = vm.production.min_price ? vm.production.min_price : 0;
            }

            let bookingStatus = Math.min(...(vm.production.performances.filter(p => ignoredStatuses.indexOf(p.status) === -1).map(p => p.status)));
            if (!bookingStatus) {
                // Fallback in case all statuses are ignored
                bookingStatus = Math.min(...(vm.production.performances.map(p => p.status)));
            }
            vm.booking_status = find(vm.production.performances, p => p.status === bookingStatus).status_description;

            // Check if any performances are off sale, if all are off sale
            // return as such, don't try to sell things off sale
            const availablePerformances = vm.production.performances.filter(perf => {
                return perf.availability > 0;
            });

            if (availablePerformances.length === 0) {
                vm.booking_url = false;
                vm.sold_out = true;
                vm.booking_status = locale === 'en' ? 'Sold Out' : 'Gwerthu allan';
                return;
            }

            if (vm.production.on_sale_date_moment <= now && vm.production.performances.length === 1) {
                vm.booking_url = vm.production.performances[0].book_url;
                vm.is_bookable = true;
            } else if (vm.production.on_sale_date_moment <= now) {
                vm.booking_url = vm.production.book_url;
                vm.is_bookable = true;
            } else {
                if (vm.logged_in) {
                    vm.booking_url = vm.production.book_url;

                    let onSaleDate = !!find(vm.production.performances, perf => {
                        return find(perf.on_sale_dates, onSaleData => {
                            return onSaleData.on_sale_date_moment <= now && onSaleData.mos === vm.current_mos;
                        });
                    });

                    if (onSaleDate) {
                        vm.is_bookable = true;
                        return;
                    }
                }

                vm.members_only = !!find(vm.production.performances, perf => {
                    return find(perf.on_sale_dates, onSaleData => {
                        return onSaleData.on_sale_date_moment <= now;
                    });
                });
            }
        }).finally(() => {
            const interval = setInterval(() => {
                if ('addeventatc' in window === false) {
                    return;
                }
                clearInterval(interval);
                addeventatc.refresh();
            }, 200);
            vm.loading = false;
        });
    }

    vm.downloadCalendarLink = ($event, on_sale_date) => {
        $event.stopPropagation();
        const cal = new ICS();
        cal.addEvent(vm.production.title, on_sale_date.label, 'Wales Millennium Centre', on_sale_date.on_sale_date_moment.format('DD/MM/YYYY'), on_sale_date.on_sale_date_moment.format('DD/MM/YYYY'));
        cal.download();
    }

    vm.init();

    return vm;
}

module.exports = [
    '$attrs',
    '$scope',
    'inventoryService',
    'locale',
    'appConfig',
    controller
]



// WEBPACK FOOTER //
// ./widgets/controllers/TicketInfo.js